module.exports = __webpack_public_path__ + "img/smarLOAlogo.c3a46be7.png";